<template>
  <v-card-text>
    <v-text-field
      v-model="guest.first_name"
      label="First Name"
      placeholder="Enter first name (optional)"
    />
    <v-text-field
      v-model="guest.last_name"
      label="Last Name"
      placeholder="Enter last name (optional)"
    />
    <v-btn
        color="primary"
        @click="generateGuest"
        :loading="loading"
    >
      Generate Guest Player
    </v-btn>
  </v-card-text>
</template>

<script>
export default {
  name: "NewGuestForm",
  data: () => ({
    loading: false,
    guest: {
      first_name: "",
      last_name: "",
    }
  }),
  props: {
    tableId: {
      type: String,
      required: true
    }
  },
  methods: {
    async generateGuest() {
      this.loading = true
      await this.$store.dispatch("GENERATE_GUEST_USER", {
        tableId: this.$props.tableId,
        first_name: this.guest.first_name,
        last_name: this.guest.last_name
      })
      this.loading = false
    }
  }
}
</script>

<style scoped>

</style>